module.exports = __webpack_public_path__ + "img/x1.8299edff.jpg";